'use client';
import React, { useContext } from 'react';
import { KeyEditorContext } from '../KeyEditorContext';

import Field from './Field';
import { Stack } from '@/ui/primatives';
import * as Styled from './styled';

import DebugJson from '@/ui/DebugJson';

const KeyPicker: React.FC<{}> = () => {
  const { mergedFields, associations, compiledDefinition, toggleKeyField, toggleTargetField, canEdit } =
    useContext(KeyEditorContext);

  // Hack to get targets to show up in the key picker
  const filteredFields = mergedFields.filter((field) => field.name !== '_targets_hash' && field.name !== '_keys_hash');

  return (
    <Styled.KeyPicker>
      <Stack gap={5}>
        {filteredFields.map((field) => {
          return (
            <Field
              key={field.name}
              canEdit={canEdit}
              schemaField={field}
              associations={associations}
              toggleKeyField={toggleKeyField}
              toggleTargetField={toggleTargetField}
            />
          );
        })}
        <DebugJson json={compiledDefinition} rootNodeName="compiledDefinition" collapseDepth={2} />
      </Stack>
    </Styled.KeyPicker>
  );
};

export default KeyPicker;
